/*
 * @Author: WH-Chen cwh2024@163.com
 * @Date: 2025-06-16 09:20:17
 * @LastEditors: WH-Chen cwh2024@163.com
 * @LastEditTime: 2025-06-22 09:50:49
 * @FilePath: \school\src\constants\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 请求成功状态码
 */
export const SUCCESS_CODE = 200

/**
 * 请求contentType
 */
export const CONTENT_TYPE: AxiosContentType = 'application/json'

/**
 * 请求超时时间
 */
export const REQUEST_TIMEOUT = 60000

/**
 * 不重定向白名单
 */
export const NO_REDIRECT_WHITE_LIST = ['/login']

/**
 * 不重置路由白名单
 */
export const NO_RESET_WHITE_LIST = [
  'Login',
  'Redirect',
  'Root',
  'userPersonal',
  'Personal',
  'PersonalCenter',
  'NoFind'
]

/**
 * 表格默认过滤列设置字段
 */
export const DEFAULT_FILTER_COLUMN = ['expand', 'selection']

/**
 * 是否根据headers->content-type自动转换数据格式
 */
export const TRANSFORM_REQUEST_DATA = true

/**
 * 全局图标前缀
 */
export const ICON_PREFIX = 'vi-'

/**
 * 年级序号
 */
export const GRADE_INDEX = new Map([
  ['1', '一年级'],
  ['2', '二年级'],
  ['3', '三年级'],
  ['4', '四年级'],
  ['5', '五年级'],
  ['6', '六年级'],
  ['7', '七年级'],
  ['8', '八年级'],
  ['9', '九年级']
])

export const weekOptions = [
  {
    label: '周一',
    value: '1'
  },
  {
    label: '周二',
    value: '2'
  },
  {
    label: '周三',
    value: '3'
  },
  {
    label: '周四',
    value: '4'
  },
  {
    label: '周五',
    value: '5'
  },
  {
    label: '周六',
    value: '6'
  },
  {
    label: '周日',
    value: '7'
  }
]
